import {JSEncrypt} from 'encryptlong'
//加密解密
const _encrypt = new JSEncrypt();
const _decrypt = new JSEncrypt();

//rsa长字符加密公钥
export const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCvxKSBEgxluScpXN+/VxjkgylNeav0gCQk6sXbYrTdWXGpJr8NFwJKTLylGeh31tE9HD5ttvyejv9caOnpDAPMt/ML4MOf+kPkslw9Ft+hhpr5+uXMcRBfi+5EUPXNzG2oeXDA/sTAx+DKf3+yNGsgpTiXJdF1nWn4M3YbZfQp6QIDAQAB'
//rsa长字符解密密钥
export const privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAK/EpIESDGW5Jylc379XGOSDKU15q/SAJCTqxdtitN1Zcakmvw0XAkpMvKUZ6HfW0T0cPm22/J6O/1xo6ekMA8y38wvgw5/6Q+SyXD0W36GGmvn65cxxEF+L7kRQ9c3Mbah5cMD+xMDH4Mp/f7I0ayClOJcl0XWdafgzdhtl9CnpAgMBAAECgYAak1vgHA99zenq6hz2fD/KRT6YdT4XoMxWPJ0f16PLF/wEfFREsWbqPwIC4JDylatbVwrlYdZ+TtazbTV4xBVKvZvvRSs7hZ6az50KmiD/9djBhDGotz/47m11f3beY7vb5hNvXaqJlcNoMB5WhvWhdoMFwrmBfidn0DhLGgdQ0QJBANS+ep/dmO5Igho4lH29qNg/gqOYe8UyQrqp0EXof9C8aHRpvsA/QBcQwpDoH6UxNPSM3+0I5ybEPkKAWQ6IOC0CQQDTgYiEwR3+AH1GvJjIXpqlMXLsrQ/07/W+lBrWKHYJsEcgP7sx8TqDyEGBPo3MUnqbMHMMrQ/1MLhSxNhRn7ItAkB7rPw2gamNJMPVoHzamG5WwJ0eo9+YJP7b6ypz6ZSccVs8Cdllg5+riQfDG96Btxh07oyjDODsDXuwR1L+erxFAkBP8jJsG6L+k6jGyBroAfpqXpqWI4RYjStSciECuiCD4QHBitVzNz9q+JLqC38FsFdvuYyDShcyEsxZXNZ3Y+mxAkEAkRgmTdLS+Dn2/yvRA0rBbYN+wNhUKkp+1ZpUav6Ke2f1Arj/cs2M3wCsJ/4C57Ycng36xo52payfycSu7tlVVg=='

//配置公钥
_encrypt.setPublicKey(publicKey);
_decrypt.setPrivateKey(privateKey);

//长字符加密
function encryptLong(val){
  //实例化一个JSEncrypt对象
  // let encrypt = new JSEncryptLong();
  // _encrypt.setPublicKey(publicKey);
  let encrypted = _encrypt.encryptLong(val); 
  return encrypted
}

//长字符解密
function decryptLong(val){
  //实例化一个JSEncrypt对象
  // let encrypt = new JSEncrypt();
  // _decrypt.setPrivateKey(privateKey);
  //设置需要解密的字符串
  let decrypted = _decrypt.decryptLong(val);
  return decrypted
}

export { encrypt, decrypt, encryptLong, decryptLong }



// WEBPACK FOOTER //
// ./src/modules/utils/jsencryptLong.js